import { Mail, MapPin, MessageCircle, PencilLine, Phone } from "lucide-react";
import { Badge } from "src/components/ui/Badge";
import { Member } from "src/redux/types/_customer.type";
import { initials } from "src/utils";
import EditMemberDialog from "./edit-member-dialog";

const PlanMembers = ({ member, index }: { member: Member; index: number }) => {
  const fullName = [member.first_name, member.middle_name, member.last_name]
    .filter(Boolean)
    .join(" ");
  const sameAsWhatsapp = member.whatsapp_number === member.phone_no;

  return (
    <div className="rounded-xl border border-slate-200 bg-gray-50 p-4 hover:border-slate-300 hover:shadow-sm transition-all relative">
      
      <div className="absolute top-3 right-3 max-w-fit">
        <EditMemberDialog member={member}>
          <button className="rounded-full p-2 border bg-white/30 backdrop-blur-md shadow-sm hover:shadow-md hover:bg-gray-200 duration-150 ease-in-out transition-all">
            <PencilLine className="size-3" />
          </button>
        </EditMemberDialog>
      </div>

      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-full flex items-center justify-center font-semibold text-sm shrink-0 bg-blue-50 text-blue-500">
          {initials(fullName)}
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h4 className="font-semibold text-slate-900 text-sm truncate mb-0 capitalize">
              {fullName}
            </h4>
            {index === 0 && (
              <Badge
                className={`text-[10px] px-2 py-0.5 rounded-full bg-primary text-white`}
              >
                Primary
              </Badge>
            )}
            <Badge className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-500">
              {member.gender === "Unknown" ? "" : member.gender}
            </Badge>
          </div>

          <div className="mt-2.5 space-y-1.5 text-xs text-slate-500">
            <div className="flex items-center gap-1.5">
              <Phone size={13} className="text-slate-400 shrink-0" />
              <span>{member.phone_no}</span>
              {!sameAsWhatsapp && member.whatsapp_number && (
                <span className="flex items-center gap-1 text-emerald-600 ml-1">
                  <MessageCircle size={12} />
                  {member.whatsapp_number}
                </span>
              )}
            </div>
            <div className="flex items-center gap-1.5">
              <Mail size={13} className="text-slate-400 shrink-0" />
              <span className="truncate">{member.email}</span>
            </div>
            <div className="flex items-start gap-1.5">
              <MapPin size={13} className="text-slate-400 shrink-0 mt-0.5" />
              <span>
                {member.address}, {member.city}, {member.district},{" "}
                {member.state} - {member.pin}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanMembers;
